import { tokens } from '../tokens.generated';

export interface T3WordmarkProps {
  /** Dark chrome (ink app bar): "thesis" renders in cream instead of ink. */
  dark?: boolean;
  /** Rendered height in px; width keeps the 220x56 viewBox ratio. */
  height?: number;
}

/**
 * The thesis3 wordmark — same structure as the Keycloak login theme logo
 * (infrastructure/keycloak/themes/platform/login/resources/img/logo.svg):
 * "thesis" (ink or cream) + pink "3" + gold rule. Colors come from tokens.
 */
export function T3Wordmark({ dark = false, height = 28 }: T3WordmarkProps) {
  const thesisFill = dark ? tokens.color.cream : tokens.color.ink;
  const width = Math.round(height * (220 / 56));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 220 56"
      role="img"
      aria-label="thesis3"
    >
      <title>{tokens.brand.wordmark}</title>
      <text
        x="8"
        y="38"
        fontFamily={tokens.font.display}
        fontWeight={900}
        fontSize={30}
        letterSpacing={1}
        fill={thesisFill}
      >
        thesis
      </text>
      <text
        x="122"
        y="38"
        fontFamily={tokens.font.display}
        fontWeight={900}
        fontSize={30}
        fill={tokens.color.pink}
      >
        3
      </text>
      <rect x="8" y="46" width="136" height="5" rx="2.5" fill={tokens.color.gold} />
    </svg>
  );
}
